<!-- RMC × Shoplift — Surface-area sizing helper (all devices as of T1's device-targeting update) -->
<!-- Paste into the Shoplift JavaScript API test editor (variant B). -->
<!-- Reads coverage figures from the live DOM, so no product data is hardcoded. -->
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1. SHOPLIFT GATE
     Replace HYPOTHESIS_ID with the id Shoplift shows for this test.

     isHypothesisActive() IS the manual trigger: calling it is what
     enrolls the visitor, and its resolved value tells you which arm
     they landed in. There is no separate "fire trigger" step. It also
     returns a Promise, so it must be awaited — treating the Promise
     object itself as the boolean would always be truthy and show the
     widget to control and variant visitors alike.

     window.shoplift may not exist yet when this script runs, so wait
     for it (poll) rather than checking once. And check eligibility
     (on a PDP + enough sized options to recommend) BEFORE calling
     isHypothesisActive — visitors who could never see the widget
     shouldn't be enrolled in the test at all.
     ------------------------------------------------------------------ */
  var HYPOTHESIS_ID = '01a08b70-2a04-7349-9c3b-5786697aeef8';
  var SDK_POLL_MS = 100;
  var SDK_POLL_MAX_ATTEMPTS = 50; // ~5s

  function waitForShoplift(callback, attempt) {
    attempt = attempt || 0;
    if (window.shoplift && typeof window.shoplift.isHypothesisActive === 'function') {
      callback();
      return;
    }
    if (attempt >= SDK_POLL_MAX_ATTEMPTS) return; // SDK never loaded: render nothing
    setTimeout(function () { waitForShoplift(callback, attempt + 1); }, SDK_POLL_MS);
  }

  /* Shoplift has no page-type/path audience filter (only UTM/URL-string-
     param/referring-domain/country), so PDP-only targeting is enforced
     here rather than in the dashboard. Matches "/products/" anywhere in
     the path so it still works under a market's locale prefix, e.g.
     /nl-nl/products/oil-plus-2c. */
  var PDP_PATH = /\/products\//;

  function eligible() {
    if (!PDP_PATH.test(window.location.pathname)) return false;
    if (document.querySelector('[data-' + PREFIX + '="root"]')) return false;
    return collectSizeOptions().length >= 2;
  }

  /* ------------------------------------------------------------------
     2. CONFIG
     ------------------------------------------------------------------ */
  var PREFIX = 'rmc-slt';
  var WASTE_FACTOR = 1.0;          // set to 1.1 to build in 10% margin

  var STRINGS = {
    en: { title: 'How much do I need?', label: 'Surface area', unit: 'm²',
          cta: 'Select', placeholder: 'e.g. 24 m²',
          result: '{size} covers about {coverage} m²',
          resultMulti: '{qty} × {size} covers about {coverage} m²',
          resultCombo: '{parts} covers about {coverage} m²',
          tooBig: 'For areas this large, contact us for project advice.',
          invalid: 'Enter your surface area in m².' },
    nl: { title: 'Hoeveel heb ik nodig?', label: 'Oppervlakte', unit: 'm²',
          cta: 'Selecteer', placeholder: 'bv. 24 m²',
          result: '{size} is genoeg voor ongeveer {coverage} m²',
          resultMulti: '{qty} × {size} is genoeg voor ongeveer {coverage} m²',
          resultCombo: '{parts} is genoeg voor ongeveer {coverage} m²',
          tooBig: 'Voor grotere oppervlakken: neem contact op voor projectadvies.',
          invalid: 'Vul je oppervlakte in m² in.' },
    fr: { title: 'De quelle quantité ai-je besoin ?', label: 'Surface', unit: 'm²',
          cta: 'Sélectionner', placeholder: 'ex. 24 m²',
          result: '{size} couvre environ {coverage} m²',
          resultMulti: '{qty} × {size} couvre environ {coverage} m²',
          resultCombo: '{parts} couvre environ {coverage} m²',
          tooBig: 'Pour les grandes surfaces, contactez-nous pour un conseil projet.',
          invalid: 'Indiquez votre surface en m².' },
    de: { title: 'Wie viel brauche ich?', label: 'Fläche', unit: 'm²',
          cta: 'Auswählen', placeholder: 'z. B. 24 m²',
          result: '{size} reicht für etwa {coverage} m²',
          resultMulti: '{qty} × {size} reicht für etwa {coverage} m²',
          resultCombo: '{parts} reicht für etwa {coverage} m²',
          tooBig: 'Für größere Flächen: kontaktieren Sie uns für Projektberatung.',
          invalid: 'Geben Sie Ihre Fläche in m² an.' },
    it: { title: 'Quanto prodotto mi serve?', label: 'Superficie', unit: 'm²',
          cta: 'Seleziona', placeholder: 'es. 24 m²',
          result: '{size} copre circa {coverage} m²',
          resultMulti: '{qty} × {size} copre circa {coverage} m²',
          resultCombo: '{parts} copre circa {coverage} m²',
          tooBig: 'Per superfici più grandi, contattaci per una consulenza.',
          invalid: 'Inserisci la superficie in m².' },
    pl: { title: 'Ile mi potrzeba?', label: 'Powierzchnia', unit: 'm²',
          cta: 'Wybierz', placeholder: 'np. 24 m²',
          result: '{size} wystarczy na około {coverage} m²',
          resultMulti: '{qty} × {size} wystarczy na około {coverage} m²',
          resultCombo: '{parts} wystarczy na około {coverage} m²',
          tooBig: 'Skontaktuj się z nami po poradę projektową.',
          invalid: 'Podaj powierzchnię w m².' },
    no: { title: 'Hvor mye trenger jeg?', label: 'Areal', unit: 'm²',
          cta: 'Velg', placeholder: 'f.eks. 24 m²',
          result: '{size} dekker omtrent {coverage} m²',
          resultMulti: '{qty} × {size} dekker omtrent {coverage} m²',
          resultCombo: '{parts} dekker omtrent {coverage} m²',
          tooBig: 'For så store arealer, kontakt oss for prosjektråd.',
          invalid: 'Skriv inn arealet i m².' },
    da: { title: 'Hvor meget skal jeg have?', label: 'Areal', unit: 'm²',
          cta: 'Vælg', placeholder: 'fx 24 m²',
          result: '{size} dækker cirka {coverage} m²',
          resultMulti: '{qty} × {size} dækker cirka {coverage} m²',
          resultCombo: '{parts} dækker cirka {coverage} m²',
          tooBig: 'For så store arealer, kontakt os for projektrådgivning.',
          invalid: 'Angiv dit areal i m².' },
    sv: { title: 'Hur mycket behöver jag?', label: 'Yta', unit: 'm²',
          cta: 'Välj', placeholder: 't.ex. 24 m²',
          result: '{size} räcker till cirka {coverage} m²',
          resultMulti: '{qty} × {size} räcker till cirka {coverage} m²',
          resultCombo: '{parts} räcker till cirka {coverage} m²',
          tooBig: 'Vid så stora ytor, kontakta oss för projektrådgivning.',
          invalid: 'Ange din yta i m².' },
    fi: { title: 'Kuinka paljon tarvitsen?', label: 'Pinta-ala', unit: 'm²',
          cta: 'Valitse', placeholder: 'esim. 24 m²',
          result: '{size} riittää noin {coverage} m²:lle',
          resultMulti: '{qty} × {size} riittää noin {coverage} m²:lle',
          resultCombo: '{parts} riittää noin {coverage} m²:lle',
          tooBig: 'Ota yhteyttä projektineuvontaa varten.',
          invalid: 'Syötä pinta-alasi m²:ssä.' }
  };

  function t() {
    var lang = (document.documentElement.getAttribute('lang') || 'en')
      .toLowerCase().split('-')[0];
    return STRINGS[lang] || STRINGS.en;
  }

  /* ------------------------------------------------------------------
     3. READ THE SIZE OPTIONS OUT OF THE DOM
     Size options are the only ones whose labels render
     .variant-coverage-estimate (from the coverage_estimation metafield).
     Options without a coverage figure (6 ml / 20 ml samples) are skipped.
     ------------------------------------------------------------------ */
  function parseNumber(str) {
    if (!str) return null;
    var m = String(str).replace(/\s/g, '').match(/(\d+(?:[.,]\d+)?)/);
    if (!m) return null;
    return parseFloat(m[1].replace(',', '.'));
  }

  function collectSizeOptions() {
    var out = [];
    var estimates = document.querySelectorAll('.variant-coverage-estimate');

    for (var i = 0; i < estimates.length; i++) {
      var label = estimates[i].closest('label');
      if (!label) continue;

      var forId = label.getAttribute('for');
      var input = forId ? document.getElementById(forId) : null;
      if (!input || input.type !== 'radio') continue;
      if (input.disabled || input.classList.contains('visually-disabled')) continue;

      var coverage = parseNumber(estimates[i].textContent);
      if (!coverage || coverage <= 0) continue;

      var nameEl = label.querySelector('.variant-label-text');
      var name = (nameEl ? nameEl.textContent : input.value || '').trim();
      // strip any visually-hidden availability text that rides along
      name = name.split('\n')[0].trim();

      out.push({ input: input, coverage: coverage, name: name });
    }

    out.sort(function (a, b) { return a.coverage - b.coverage; });
    return out;
  }

  /* ------------------------------------------------------------------
     4. RECOMMENDATION LOGIC
     Returns a plan: an array of { option, qty } line items, largest first.
     Tries every size as a "base" (any quantity from 0 up to MAX_QTY),
     each paired with at most one "top-up" size at the minimum quantity
     needed to reach the target, and picks whichever candidate wastes
     least coverage. Ties are broken by: fewest total containers, then
     fewest distinct sizes, then the plan built around the larger base
     size — so a single-size answer wins over an equally-wasteful mixed
     one, and "1 big + 1 small" is preferred over "many small".

     Found via manual testing (a 44 m² target on DuroGrit): the previous
     version only ever compared the single largest size against ONE
     smaller pair, so it recommended a single 5 L (57.5 m², wasting
     13.5 m²) without ever checking that 4 × 1 L covers 46 m² for only
     2 m² of waste. Trying every size as the base, at any quantity, is
     what actually finds this — a fixed pair-only search (tried next)
     still missed it, since 4× the same size isn't a "pair".
     ------------------------------------------------------------------ */
  function recommend(area, options) {
    var target = area * WASTE_FACTOR;
    if (!options.length) return null;

    var MAX_QTY = 12; // sanity cap: never recommend absurd quantities
    var candidates = [];

    for (var i = 0; i < options.length; i++) {
      for (var qi = 0; qi <= MAX_QTY; qi++) {
        var coverI = qi * options[i].coverage;

        if (qi > 0 && coverI >= target) {
          candidates.push({ plan: [{ option: options[i], qty: qi }], coverage: coverI, units: qi });
        }

        var remainder = target - coverI;
        if (remainder <= 0) continue; // qi alone already covers it (handled above)

        for (var j = 0; j < options.length; j++) {
          if (j === i) continue;
          var qj = Math.ceil(remainder / options[j].coverage);
          if (qj < 1 || qi + qj > MAX_QTY) continue;

          var totalCoverage = coverI + qj * options[j].coverage;
          var plan = qi > 0
            ? [{ option: options[i], qty: qi }, { option: options[j], qty: qj }]
            : [{ option: options[j], qty: qj }];
          candidates.push({ plan: plan, coverage: totalCoverage, units: qi + qj });
        }
      }
    }

    if (!candidates.length) return null;

    candidates.sort(function (p, q) {
      if (p.coverage !== q.coverage) return p.coverage - q.coverage; // least waste first
      if (p.units !== q.units) return p.units - q.units; // fewest containers
      if (p.plan.length !== q.plan.length) return p.plan.length - q.plan.length; // fewest distinct sizes
      var pMax = Math.max.apply(null, p.plan.map(function (e) { return e.option.coverage; }));
      var qMax = Math.max.apply(null, q.plan.map(function (e) { return e.option.coverage; }));
      return qMax - pMax; // prefer the plan built around the larger size
    });

    var best = candidates[0].plan.slice();
    best.sort(function (a, b) { return b.option.coverage - a.option.coverage; });
    return best;
  }

  /* ------------------------------------------------------------------
     5. APPLY THE SELECTION
     Only the primary (largest-quantity) line item can be pre-filled —
     the PDP has one variant selector, so a second, different-sized item
     can't be auto-added to the same selection. The result text spells
     out the full plan; the shopper adds any top-up size separately.
     ------------------------------------------------------------------ */
  function applySelection(plan) {
    var primary = plan[0];
    if (!primary.option.input.checked) {
      primary.option.input.click();
    }
    if (primary.qty > 1) {
      var q = document.querySelector('.quantity__input, input[name="quantity"]');
      if (q) {
        q.value = primary.qty;
        q.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    var btn = document.querySelector('.product-form__submit');
    if (btn && typeof btn.scrollIntoView === 'function') {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      btn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
  }

  /* ------------------------------------------------------------------
     6. BUILD THE WIDGET
     ------------------------------------------------------------------ */
  function styles() {
    if (document.getElementById(PREFIX + '-styles')) return;
    var css = document.createElement('style');
    css.id = PREFIX + '-styles';
    css.textContent = [
      /* !important on the box-model properties: the theme's own
         `.product__info-container > * + *` rule (section-main-product.css)
         has identical specificity to `.PREFIX-box`, and on this page it
         happens to be inserted later in the document than our injected
         <style> tag — so on a plain specificity tie it was winning and
         overwriting `margin:16px auto` with its own `margin:0 0 1.5rem`,
         collapsing our centering to flush-left. Confirmed via
         getComputedStyle + a live cascade-rule dump (both Oil Plus 2C and
         DuroGrit) before adding !important; re-verified centered (43px/43px
         equal gaps in the ~506px column) on both after. */
      '.' + PREFIX + '-box{box-sizing:border-box!important;max-width:420px!important;width:100%!important;margin:16px auto!important;border:1px solid #d9ddd9;border-radius:10px;padding:14px;background:#f7f8f7;font-size:15px;line-height:1.4}',
      '.' + PREFIX + '-title{font-weight:600;margin:0 0 10px;font-size:15px}',
      '.' + PREFIX + '-row{display:flex;gap:8px;align-items:stretch}',
      '.' + PREFIX + '-field{position:relative;flex:1 1 auto}',
      '.' + PREFIX + '-input{width:100%;box-sizing:border-box;padding:11px 42px 11px 12px;border:1px solid #b9c0b9;border-radius:8px;font-size:16px;background:#fff;-webkit-appearance:none;appearance:none}',
      '.' + PREFIX + '-unit{position:absolute;right:12px;top:50%;transform:translateY(-50%);color:#5c665c;font-size:14px;pointer-events:none}',
      '.' + PREFIX + '-cta{flex:0 0 auto;padding:11px 16px;border:0;border-radius:8px;background:#183029;color:#fff;font-size:15px;font-weight:600;cursor:pointer}',
      '.' + PREFIX + '-cta[disabled]{opacity:.45;cursor:default}',
      '.' + PREFIX + '-out{margin:10px 0 0;color:#183029}',
      '.' + PREFIX + '-out[data-state="error"]{color:#8a2b2b}'
    ].join('');
    document.head.appendChild(css);
  }

  function build(options) {
    var s = t();
    var box = document.createElement('div');
    box.className = PREFIX + '-box';
    box.setAttribute('data-' + PREFIX, 'root');

    var title = document.createElement('p');
    title.className = PREFIX + '-title';
    title.textContent = s.title;

    var row = document.createElement('div');
    row.className = PREFIX + '-row';

    var field = document.createElement('div');
    field.className = PREFIX + '-field';

    var input = document.createElement('input');
    input.className = PREFIX + '-input';
    input.type = 'number';
    input.min = '1';
    input.step = '1';
    input.inputMode = 'numeric';
    input.placeholder = s.placeholder;
    input.setAttribute('aria-label', s.label + ' (' + s.unit + ')');

    var unit = document.createElement('span');
    unit.className = PREFIX + '-unit';
    unit.textContent = s.unit;

    var cta = document.createElement('button');
    cta.className = PREFIX + '-cta';
    cta.type = 'button';
    cta.textContent = s.cta;

    var out = document.createElement('p');
    out.className = PREFIX + '-out';
    out.setAttribute('role', 'status');
    out.setAttribute('aria-live', 'polite');
    out.hidden = true;

    field.appendChild(input);
    field.appendChild(unit);
    row.appendChild(field);
    row.appendChild(cta);
    box.appendChild(title);
    box.appendChild(row);
    box.appendChild(out);

    function run() {
      var area = parseNumber(input.value);
      out.hidden = false;

      if (!area || area <= 0) {
        out.setAttribute('data-state', 'error');
        out.textContent = s.invalid;
        return;
      }

      var live = collectSizeOptions();
      var plan = recommend(area, live.length ? live : options);

      if (!plan) {
        out.setAttribute('data-state', 'error');
        out.textContent = s.tooBig;
        return;
      }

      var total = 0;
      for (var i = 0; i < plan.length; i++) {
        total += plan[i].option.coverage * plan[i].qty;
      }
      total = Math.round(total);

      out.removeAttribute('data-state');
      if (plan.length > 1) {
        var parts = plan.map(function (item) {
          return item.qty > 1 ? (item.qty + ' × ' + item.option.name) : item.option.name;
        }).join(' + ');
        out.textContent = s.resultCombo.replace('{parts}', parts).replace('{coverage}', total);
      } else {
        var tpl = plan[0].qty > 1 ? s.resultMulti : s.result;
        out.textContent = tpl
          .replace('{qty}', plan[0].qty)
          .replace('{size}', plan[0].option.name)
          .replace('{coverage}', total);
      }

      applySelection(plan);
    }

    cta.addEventListener('click', run);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); run(); }
    });

    return box;
  }

  /* ------------------------------------------------------------------
     7. MOUNT + SELF-HEAL
     Dawn re-renders the product section on every variant change, which
     wipes injected nodes. The observer re-mounts when that happens.
     ------------------------------------------------------------------ */
  function mountPoint(options) {
    /* .quantity-add-to-cart wraps the quantity stepper + Add to Cart
       button as one row, and is a direct child of the full-width info
       column on every product checked so far — inserting before it is a
       stable anchor regardless of how the size picker itself is marked
       up. Prefer this over anchoring to the size fieldset: whether
       options[0].input sits inside a <label> (so .closest('label') even
       resolves) varies by product — confirmed nested on Oil Plus 2C,
       siblings instead on DuroGrit — and that inconsistency was landing
       the widget inside a much narrower nested wrapper (~340px, sized to
       just the button) instead of the full column (~500px+). */
    var cartRow = document.querySelector('.quantity-add-to-cart');
    if (cartRow && cartRow.parentNode) return { parent: cartRow.parentNode, before: cartRow };

    var firstLabel = options[0].input.closest('label');
    var group = firstLabel ? firstLabel.closest('fieldset, .product-form__input') : null;
    if (group && group.parentNode) return { parent: group.parentNode, before: group.nextSibling };

    var form = document.querySelector('product-form, .product-form');
    if (form && form.parentNode) return { parent: form.parentNode, before: form };

    return null;
  }

  function mount() {
    if (document.querySelector('[data-' + PREFIX + '="root"]')) return;

    var options = collectSizeOptions();
    if (options.length < 2) return;   // fail safe: render nothing, control experience

    var target = mountPoint(options);
    if (!target) return;

    styles();
    target.parent.insertBefore(build(options), target.before);
  }

  function boot() {
    waitForShoplift(function () {
      if (!eligible()) return; // nothing to show here: don't enroll the visitor at all

      window.shoplift.isHypothesisActive(HYPOTHESIS_ID).then(function (isActive) {
        if (!isActive) return; // control arm: visitor is enrolled, render nothing

        mount();

        var pending = null;
        var observer = new MutationObserver(function () {
          clearTimeout(pending);
          pending = setTimeout(mount, 150);
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }).catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
